import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Empresa } from 'app/entities/cobranza';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { BusquedaXNombreComponent } from 'app/modals/cartera/busqueda-x-nombre/busqueda-x-nombre.component';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AddDebitoAutoComponent } from 'app/modals/debito-auto/add-debito-auto/add-debito-auto.component';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { DebitoService } from 'app/services/debito.service';

@Component({
  selector: 'app-agregar-debito-auto',
  templateUrl: './agregar-debito-auto.component.html',
  styleUrls: ['./agregar-debito-auto.component.scss']
})
export class AgregarDebitoAutoComponent implements OnInit, AfterViewInit, OnDestroy {

  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective , {static: true})
  tabla: DataTableDirective;
  public dtTrigger: Subject<void> = new Subject();
  public isNull_grupo: boolean = false;
  public selected_toogleGroup: string;
  public selected_tabGroup: number;
  public empresa: Empresa;
  newForm: FormGroup;

  constructor
  (
    private _dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private _cartera: CarteraService,
    private _debito: DebitoService
  ) 
  {
    this.selected_toogleGroup = '0';
    this.empresa = {
      nombre: 'Red Médica Vital',
      base_datos: 'medisoft',
      indice: '1'
    }
    this.dtTrigger.next();
    this.newForm = this.createForm();
  }

  ngOnInit() {
    this.dtOptions = {
      responsive: true,
      language: {
        lengthMenu: `Número de _MENU_ registros por página`,
        zeroRecords: `Datos no encontrados - Lo sentimos`,
        info: `Mostrando la página _PAGE_ de _PAGES_`,
        infoEmpty: `No hay registros disponibles`,
        infoFiltered: `(Filtrado de _MAX_ registros totales)`,
        LoadingRecords: `Cargando...`,
        search: `Buscar:`,
        paginate: {
          first:   `Primero`,
          last:    `Último`,
          next:    `Siguiente`,
          previous:`Anterior`
        }
      },
      columns: [
        {},
        {
          data: 'nombre_grupo'
        },
        {
          data: 'codigo_grupo'
        },
        {
          data: 'radicado_grupo'
        },
        {
          data: 'ciclo_grupo'
        },
        {
          data: 'estado_grupo'
        },
        {},
        {
          data: 'Debito_automatico'
        }
      ]
    }
  }

  createForm(): FormGroup {
    return new FormGroup({
      documento: new FormControl(null, [
        Validators.pattern('[A-Za-z0-9]+')
      ]),
      radicado: new FormControl(null, [
        Validators.pattern('[A-Za-z0-9]+')
      ])
    });
  }

  public selectedEmpresa(empresa: string){
    this.empresa = {
      nombre: empresa === '0' ? 'Red Médica Vital' : 'VitalMascotas',
      base_datos: empresa === '0' ? 'medisoft' : 'medisoftvet',
      indice: empresa === '0' ? '1' : '2'
    }
    this.newForm.reset();
  }

  public busquedaxNombre(): void{
    let modal;
    modal = this._dialog.open(BusquedaXNombreComponent, {
      width: '40vw'
    });
    modal.afterClosed().subscribe((result: any) => {
      this.empresa = {
        nombre: result.empresa === '0'? 'Red Médica Vital' : 'VitalMascotas',
        base_datos: result.empresa === '0'? 'medisoft' : 'medisoftvet',
        indice: result.empresa === '0'? '1' : '2'
      }
      this.selected_toogleGroup = result.empresa === '0' ? '0' : '1';
      this.selected_tabGroup = 1;
      this.newForm.get('radicado').setValue(result.radicado);
    });
  }

  public busquedaInfoGrupo(form: any): void {
    if(this.ValidacionesForm(form)){
      this._cartera.VerInfoGrupo(form.radicado, form.documento, this.empresa.base_datos).subscribe((data: any) => {
        if(data.length){
          this.tableOpt = data;
          this.renderer();
          this.isNull_grupo = false;
          this.empresa.tp_contrato = data[0].tipo_contrato;
        }else{
          this.isNull_grupo = true;
        }
      });
    }else{
      return;
    }
  }

  ValidacionesForm(form: any): boolean {
    if(!form.documento && !form.radicado){
      this._snackBar.open('Error: Campo Requerido', '', {
        panelClass: ['warn-600'],
        duration: 2500
      });
      return false;
    }
    return true;
  }

  renderer(): void{
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  public modalAddDebitoAuto(): void {
    let modal: any;
    modal = this._dialog.open(AddDebitoAutoComponent, {
      width: '45%',
      height: '60%',
      panelClass: 'custom-dialog-container',
      data: {
        base_datos: this.empresa.base_datos,
        grupo: this.tableOpt[0].id_grupo
      }
    });

    modal.afterClosed().subscribe((result: boolean) => {
      if(result) this.busquedaInfoGrupo(this.newForm.value);
    });
  }

  public modalDeleteDebitoAuto(): void {
    let modal: any;
    modal = this._dialog.open(FuseConfirmDialogComponent, {
      data: {
        mensaje: '¿Desea eliminar débito automático?'
      }
    });

    modal.afterClosed().subscribe((result: boolean) => {
      if(result){
        this._debito.QuitarDebitoAuto(this.empresa.base_datos, this.tableOpt[0].id_grupo).subscribe((data: any) => {
          if(data['affectedRows'] > 0){
            this._snackBar.open('Débito Automático Eliminado', 'Aceptar', {
              duration: 2000
            });
            this.busquedaInfoGrupo(this.newForm.value);
          }else{
            this._snackBar.open('Error al eliminar Débito Automático', '', {
              duration: 2500,
              panelClass: 'warn-500'
            });
          }
        });
      }
    });
  }




}
